import { WeatherLocation } from '../../../types';

export const DEFAULT_LOCATION: WeatherLocation = {
  latitude: 51.509865,
  longitude: -0.118092,
  name: 'London',
};

export const YOUR_LOCATION_NAME = 'Your location';
export const NUMBER_OF_DAYS = 7;

// Narrowest desktop width (px) that keeps the widest row on one line: icon +
// "Thunderstorm & Hail" + the "Temperature / Chance of rain" switch, plus card padding.
export const WEATHER_WIDGET_MIN_WIDTH = 710;

// Stable reference for AppDashboard's `widgetMinWidths` (keyed by system_name).
export const WEATHER_WIDGET_MIN_WIDTHS: Record<string, number> = { weather: WEATHER_WIDGET_MIN_WIDTH };
